<template>
  <div class="rubric-filter">
    <div class="filters-row d-flex align-items-center flex-gap-1">
      <eg-table-filters-base
        :available-filters="['gradeLevel', 'languageId']"
        :all-available-filters="allAvailableFilters"
        :default-selected-filters="defaultSelectedFilters"
        :show-add-filter="false"
        :can-remove-filters="false"
        :show-clear-all="false"
        :show-search="true"
        :right-dropdown-index="2"
        :filters-size="filtersSize"
        class="rubric-filter-filters"
        data-testid="rubric-filter-filters"
        @filter-changed="handleFilterChanged"
      >
      </eg-table-filters-base>
    </div>
  </div>
</template>

<script>
import { GRADE_LEVELS } from "@/constants";
import { mapGetters } from "vuex";
import { EgTableFiltersBase } from "@/components/global/eg/eg_table";

export default {
  name: "RubricFilter",

  components: {
    EgTableFiltersBase,
  },

  props: {
    value: {
      type: Object,
      default: () => ({
        name: "",
        gradeLevel: null,
        languageId: null,
      }),
    },
    filtersSize: {
      type: String,
      default: "small",
    },
  },

  emits: ["input"],

  data() {
    return {
      languageItems: [],
      defaultSelectedFilters: [
        { key: "gradeLevel", value: null, isActive: false },
        { key: "languageId", value: null, isActive: false },
      ],
    };
  },

  computed: {
    ...mapGetters("languages", ["getLanguagesList"]),

    allAvailableFilters() {
      return {
        gradeLevel: {
          title: this.$t("rubrics.gradeFilter"),
          key: "gradeLevel",
          prepareValue: (value) =>
            this.allAvailableFilters.gradeLevel.items.find(
              (item) => item.id === value
            ),
          component: "filter-select",
          items: GRADE_LEVELS.map((level) => ({
            id: level.value,
            name: this.$t(level.translationKey),
          })),
        },
        languageId: {
          title: this.$t("rubrics.languageFilter"),
          key: "languageId",
          prepareValue: (value) =>
            this.allAvailableFilters.languageId.items.find(
              (item) => item.id === value
            ),
          component: "filter-select",
          items: this.languageItems,
        },
      };
    },
  },

  watch: {
    getLanguagesList: {
      handler(languages) {
        this.languageItems = languages.map((lang) => ({
          id: lang.value,
          name: lang.text,
        }));
      },
      immediate: true,
    },
  },

  methods: {
    handleFilterChanged({ filters }) {
      // Normalize filter values: convert falsy values to null for consistency
      const normalizedFilters = Object.entries(filters).reduce(
        (acc, [key, value]) => {
          acc[key] = value || null;
          return acc;
        },
        {}
      );

      this.$emit("input", {
        ...this.value,
        ...normalizedFilters,
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.rubric-filter {
  font-size: 14px;
  font-weight: 400;
  flex: 1;
  line-height: 1;
  background-color: var(--color-surface-neutral-canvas);
  padding: 16px 0;
  position: sticky;
  top: 0;
  z-index: 1;
}

.filters-row {
  display: flex;
  align-items: center;
  flex-wrap: nowrap;
  gap: 1rem;

  // Override base styles for sidebar usage
  ::v-deep .rubric-filter-filters {
    display: flex;
    padding: 0 !important;
    border-bottom: none !important;
    background: transparent;
    gap: 1rem;
    flex: 1;

    .filters {
      flex: 1;
      justify-content: start;
      gap: 8px;
    }

    // Styles for filter buttons
    .dropdown:not(.active) .btn-outline-secondary {
      background-color: white;
    }
    .btn-outline-secondary {
      min-width: 115px;
      > div:first-of-type {
        justify-content: space-between;
      }

      .chevron {
        position: absolute;
        top: 13px;
        right: 10px;
      }
    }
  }
}

// Styles for search input
.search-input {
  max-width: 250px;
  flex-shrink: 0;
  height: calc(1.5em + 0.75rem);
}
</style>
